/** Lowercase alias / nickname → canonical game name (same keys as ALL_GAME_NAMES entries). */
export const GAME_SEARCH_ALIASES = {
  cs: 'Counter-Strike 2',
  cs2: 'Counter-Strike 2',
  'cs:go': 'Counter-Strike 2',
  csgo: 'Counter-Strike 2',
  counterstrike: 'Counter-Strike 2',
  'counter strike': 'Counter-Strike 2',
  cod: 'Call of Duty',
  'call of duty': 'Call of Duty',
  fortnite: 'Fortnite',
  fn: 'Fortnite',
  val: 'Valorant',
  valorant: 'Valorant',
  rl: 'Rocket League',
  'rocket league': 'Rocket League',
  lol: 'League of Legends',
  league: 'League of Legends',
  apex: 'Apex Legends',
  'apex legends': 'Apex Legends',
  r6: 'Rainbow Six Siege',
  'rainbow six': 'Rainbow Six Siege',
  siege: 'Rainbow Six Siege',
  tarkov: 'Escape from Tarkov',
  eft: 'Escape from Tarkov',
  'escape from tarkov': 'Escape from Tarkov',
  wow: 'Warcraft',
  'world of warcraft': 'Warcraft',
  warcraft: 'Warcraft',
  roblox: 'Roblox',
  rbx: 'Roblox',
  minecraft: 'Minecraft',
  mc: 'Minecraft',
  gta: 'Grand Theft Auto 5',
  gta5: 'Grand Theft Auto 5',
  'gta v': 'Grand Theft Auto 5',
  'grand theft auto': 'Grand Theft Auto 5',
  grand: 'Grand Roleplay',
  grandrp: 'Grand Roleplay',
  grp: 'Grand Roleplay',
  'grand roleplay': 'Grand Roleplay',
  fc: 'EA Sports FC',
  fifa: 'EA Sports FC',
  'ea sports': 'EA Sports FC',
  // PoE1 vs PoE2: do not map bare "path of exile" / "poe" to one title — rankedSearchGames
  // treats an exact alias key as a single-game result and hides the other game entirely.
  poe1: 'Path of Exile',
  'poe 1': 'Path of Exile',
  'path of exile 1': 'Path of Exile',
  poe2: 'Path of Exile 2',
  'poe 2': 'Path of Exile 2',
  'path of exile 2': 'Path of Exile 2',
  genshin: 'Genshin Impact',
  'genshin impact': 'Genshin Impact',
  honkai: 'Honkai Star Rail',
  'honkai star rail': 'Honkai Star Rail',
  hsr: 'Honkai Star Rail',
  diablo: 'Diablo 4',
  'diablo 4': 'Diablo 4',
  d4: 'Diablo 4',
  destiny: 'Destiny 2',
  'destiny 2': 'Destiny 2',
  d2: 'Destiny 2',
  dota: 'Dota 2',
  'dota 2': 'Dota 2',
  dbz: 'Dragon Ball Z Dokkan Battle',
  'dragon ball': 'Dragon Ball Z Dokkan Battle',
  brawl: 'Brawl Stars',
  'brawl stars': 'Brawl Stars',
  clash: 'Clash Royale',
  'clash royale': 'Clash Royale',
  coc: 'Clash of Clans',
  'clash of clans': 'Clash of Clans',
  dbd: 'Dead By Daylight',
  'dead by daylight': 'Dead By Daylight',
  deadbydaylight: 'Dead By Daylight',
  'dead by daylight boosting': 'Dead By Daylight',
  tfd: 'The First Descendant',
  'the first descendant': 'The First Descendant',
  'first descendant': 'The First Descendant',
  'first descendant boosting': 'The First Descendant',
  'delta force': 'Delta Force',
  'delta force boosting': 'Delta Force',
  ml: 'Mobile Legends',
  mlbb: 'Mobile Legends',
  'mobile legends': 'Mobile Legends',
  nw: 'New World',
  'new world': 'New World',
  'new-world': 'New World',
  'new world boosting': 'New World',
};
